import { render, staticRenderFns } from "./PortcallsFormHeader.vue?vue&type=template&id=7f82cc10"
import script from "./PortcallsFormHeader.vue?vue&type=script&lang=js"
export * from "./PortcallsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports